import {Component, Inject, Injectable, Input, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material/typings/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';
import {ApiResponseModel} from '../../../shared/entities/api-response.model';
import {HttpErrorResponse} from '@angular/common/http';
import {ValidationMessageService} from '../../../shared/services/validation-message-handle';
import {ToastrService} from 'ngx-toastr';
import {JobTypeModel} from '../../models/jobType.model';
import {JobTypeService} from '../../services/jobType.service';
import {DeleteDialogComponent} from '../../../shared/components/delete-dialog/delete-dialog.component';

@Component({
  selector: 'app-create-job-types',
  templateUrl: './create-job-types.component.html',
  styleUrls: ['./create-job-types.component.scss']
})
export class CreateJobTypesComponent implements OnInit, OnDestroy {

  public objectForm: FormGroup;
  public loading: boolean = false;

  constructor(
      @Inject(MAT_DIALOG_DATA)
      public thisObject: JobTypeModel,
      private dialog: MatDialog,
      private dialogRef: MatDialogRef<CreateJobTypesComponent>,
      private _formBuilder: FormBuilder,
      private jobTypeService: JobTypeService,
      private validationMessageService: ValidationMessageService,
      private toastr: ToastrService
  ) {

  }

  ngOnInit(): void {

    this.objectForm = this._formBuilder.group({
      name   : ['', Validators.required],
    });

    if(this.thisObject) {

      this.objectForm.patchValue({
        name: this.thisObject.name,
      });

    }
  }

  ngOnDestroy(): void {

  }

  create(): void
  {

    const data = new JobTypeModel().map(this.objectForm.getRawValue());
    this.loading = true;
    this.jobTypeService.create(data)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.toastr.success('Succes!', 'Tip-ul a fost salvata cu succes!');
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.objectForm, '' ,true);
          }
        });
  }

  update(): void
  {

    const data = new JobTypeModel().map(this.objectForm.getRawValue());
    data.uid = this.thisObject.uid;
    this.loading = true;
    this.jobTypeService.update(data)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.toastr.success('Succes!', 'Tip-ul a fost modificata cu succes!');
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.objectForm, '' , true);
          }
        });
  }

  onClickSave(): void
  {

    if(this.thisObject) {
      this.update();
    }else{
      this.create();
    }


    this.dialogRef.close(this.objectForm.getRawValue());
  }

  onClickCancel(): void
  {
    this.dialogRef.close();

  }

  onDeleteClick(): void {

    const dialogConfig = new MatDialogConfig();
    this.dialog.open(DeleteDialogComponent, dialogConfig).afterClosed().subscribe(result => {
      if(result === true){

        const data = new JobTypeModel().map(this.objectForm.getRawValue());
        data.uid = this.thisObject.uid;
        this.loading = true;
        this.jobTypeService.delete(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response) => {
              this.toastr.success('Succes!', 'Tip-ul a fost sters cu succes!');
              this.dialogRef.close(this.objectForm.getRawValue());
            }, err => {
              if (err instanceof HttpErrorResponse) {
                this.validationMessageService.serverSideValidation(err, this.objectForm, '' , true);
              }
            });
      }
    });
  }

}
